import { Outlet } from 'react-router-dom';

/**
 * 活动详情域路由壳：承载 /activities/:id 下各子页面。
 */
export default function ActivityDetailShell() {
  return <Outlet />;
}
